import { CardList } from '@/components';
import { Flex, ListItem, Skeleton } from '@blockanalitica/ui';

export type ListSkeletonProps = {
  rows?: number;
};

export default function ListSkeleton({ rows = 3, ...rest }: ListSkeletonProps) {
  return (
    <CardList
      title={
        <Flex height="4" alignItems="center">
          <Skeleton width="10" />
        </Flex>
      }
      {...rest}>
      {new Array(rows).fill(0).map((_, index) => (
        <ListItem key={index}>
          <Flex height="5">
            <Skeleton height="2" />
          </Flex>
        </ListItem>
      ))}
    </CardList>
  );
}
